<div class="split-transaction">
  @for (child of children; track child.id ?? $index; let i = $index) {
    <div class="split-transaction-item" data-testid="split-transaction-row" [attr.data-split-index]="i">
      <app-select-bucket-typeahead
        [buckets]="buckets()"
        [selectedBucket]="getBucket(child.bucketId)"
        (selectedBucketChange)="updateChildBucket(child, $event)"
        [required]="true"
        hideLabel
      />
      <app-ui-field
        class="split-transaction-row-field"
        label="Amount"
        [inputId]="'split-transaction-amount-' + i"
        [errorLines]="0"
        hideLabel
      >
        <app-ui-currency-input
          [inputId]="'split-transaction-amount-' + i"
          testId="split-transaction-amount"
          [name]="'split-transaction-amount-' + i"
          placeholder="Amount"
          [min]="null"
          required
          [(ngModel)]="child.amount"
        />
      </app-ui-field>
      @if (children.length > 1) {
        <button
          appUiButton
          appearance="ghost"
          tone="danger"
          iconOnly
          type="button"
          class="split-transaction-delete"
          [attr.aria-label]="'Delete split ' + (i + 1)"
          (click)="deleteSplit(i)"
        >
          <span class="split-transaction-action-icon" aria-hidden="true">×</span>
        </button>
      }
    </div>
  }

  <div class="split-transaction-footer">
    <button
      appUiButton
      appearance="outline"
      tone="accent"
      size="compact"
      type="button"
      class="split-transaction-add"
      data-testid="split-transaction-add"
      (click)="addSplit()"
    >
      <span>Add split</span>
      <span class="split-transaction-action-icon" aria-hidden="true">⇅</span>
    </button>

    @if (diff > 0) {
      <span class="split-transaction-balance" data-testid="split-remaining" aria-live="polite"> Over by {{ diff | currency: 'USD' : 'symbol' : '1.2-2' }} </span>
    }
    @if (diff < 0) {
      <span class="split-transaction-balance" data-testid="split-remaining" aria-live="polite"> {{ diff * -1 | currency: 'USD' : 'symbol' : '1.2-2' }} remaining </span>
    }
    @if (diff === 0) {
      <span class="split-transaction-balance" data-testid="split-remaining" aria-live="polite">All assigned</span>
    }

    @if (!embedded()) {
      <button appUiButton appearance="outline" tone="neutral" type="button" (click)="cancelSplit()">Cancel</button>
      <button
        appUiButton
        type="button"
        [disabled]="diff !== 0"
        class="split-transaction-actions-save"
        (click)="saveSplit()"
      >
        Save
      </button>
    }
  </div>
</div>
